import React from "react";
import styled from "styled-components";
import { useIntl, navigate } from "gatsby-plugin-intl";
import marked from "marked";
import get from "lodash/get";

import KCButton from "Components/KCButton";

const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: ${(props) => props.theme.color[props.textColor]};
`;

const StyledTitle = styled.div`
  font-weight: 600;
  font-size: 2rem;
  text-align: left;
  line-height: 1.8rem;
`;

const StyledSubtitle = styled.div`
  margin-top: 0.3rem;
  text-transform: uppercase;
  font-weight: 600;
  font-size: 1rem;
  opacity: 0.6;
`;

const StyledContent = styled.div`
  margin-top: 0.8rem;
  font-size: 1rem;
  opacity: 0.8;
  line-height: 1.4rem;
`;

const StyledCTAWrapper = styled.div`
  margin-bottom: 1.2rem;
  display: flex;
  & > *:not(:first-child) {
    margin-left: 0.4rem;
  }
`;

export default function ContentModal({
  title,
  subtitle,
  content,
  ctas,
  isInvert = false,
  ...props
}) {
  const intl = useIntl();
  return (
    <StyledWrapper textColor={props.labelColor}>
      <StyledSubtitle>{get(subtitle, intl.locale, "")}</StyledSubtitle>
      <StyledTitle>{get(title, intl.locale, "")}</StyledTitle>
      <StyledContent>
        <div
          dangerouslySetInnerHTML={{
            __html: marked(get(content, intl.locale, "")),
          }}
        />
      </StyledContent>
      <StyledCTAWrapper>
        {ctas &&
          ctas.map((cta, i) => {
            return (
              <KCButton
                buttonType={cta.type}
                size="small"
                isInvert={props.backgroundColor === "black"}
                key={`contentModal-cta-${i}`}
                label={get(cta, `label[${intl.locale}]`, "")}
                handleClick={() => navigate(cta.link)}
              />
            );
          })}
      </StyledCTAWrapper>
    </StyledWrapper>
  );
}
